/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetDocumentArea = {
    DomesticRealEstate: 'DomesticRealEstate',
    ForeignRealEstate: 'ForeignRealEstate',
    BuildingSavingsContracts: 'BuildingSavingsContracts',
    SavingsAccounts: 'SavingsAccounts',
    LifeInsurances: 'LifeInsurances',
    PensionInsurances: 'PensionInsurances',
    SecuritiesDepots: 'SecuritiesDepots',
    CashAndBankAssets: 'CashAndBankAssets',
    Vehicles: 'Vehicles',
    BuildingsOnForeignLand: 'BuildingsOnForeignLand',
    TenancyRights: 'TenancyRights',
    CompanyShares: 'CompanyShares',
    CooperativeMemberships: 'CooperativeMemberships',
    OtherPropertyRights: 'OtherPropertyRights',
    Donations: 'Donations'
} as const;
export type AssetDocumentArea = typeof AssetDocumentArea[keyof typeof AssetDocumentArea];


export function instanceOfAssetDocumentArea(value: any): boolean {
    for (const key in AssetDocumentArea) {
        if (Object.prototype.hasOwnProperty.call(AssetDocumentArea, key)) {
            if (AssetDocumentArea[key as keyof typeof AssetDocumentArea] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetDocumentAreaFromJSON(json: any): AssetDocumentArea {
    return AssetDocumentAreaFromJSONTyped(json, false);
}

export function AssetDocumentAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDocumentArea {
    return json as AssetDocumentArea;
}

export function AssetDocumentAreaToJSON(value?: AssetDocumentArea | null): any {
    return value as any;
}

export function AssetDocumentAreaToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetDocumentArea {
    return value as AssetDocumentArea;
}

